import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QUERIES } from '@/constants/queries'
import { approveRequest } from '@/services/requests/approve-request'
import { disapproveRequest } from '@/services/requests/disapprove-request'

export const useStudentReviewModal = (closeModal: (value: boolean) => void) => {
  const queryCLient = useQueryClient()

  const { mutate: mutateApproveRequest, isPending: isPendingApprove } =
    useMutation({
      mutationFn: (requestId?: string) => approveRequest(requestId),
      onSuccess: () => {
        queryCLient.invalidateQueries({
          queryKey: [QUERIES.QUERY_GET_REQUEST_BY_ID]
        })
        closeModal(true)
      }
    })

  const { mutate: mutateDisapproveRequest, isPending: isPendingDisapprove } =
    useMutation({
      mutationFn: (requestId?: string) => disapproveRequest(requestId),
      onSuccess: () => {
        queryCLient.invalidateQueries({
          queryKey: [QUERIES.QUERY_GET_REQUEST_BY_ID]
        })
        closeModal(true)
      }
    })

  return {
    states: {
      isPendingApprove,
      isPendingDisapprove
    },
    actions: {
      mutateApproveRequest,
      mutateDisapproveRequest
    }
  }
}
